import { useFetchPage } from "~/core/composables/useFetchPage";
import { useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import { FiltersType } from "~/core/models/filters";
import delegationService from "~/modules/relation/delegation/services/delegation.service";

export function useFetchUserDelegations({
  organizationCode,
  businessUnitCode,
}: UseFetchParameters) {
  let service =
    delegationService.getOrganizationUserDelegations.bind(delegationService);
  if (businessUnitCode) {
    service =
      delegationService.getBusinessUnitUserDelegations.bind(delegationService);
  }

  const { searchParams } = useSearch(FiltersType.RSQL);

  const { sort } = useSort();
  const { isLoading, results, allResults, error, fetchData, fetchAllData } =
    useFetchPage({
      organizationCode,
      businessUnitCode,
      service,
      sort,
      searchParams,
    });

  return {
    isLoading,
    results,
    allResults,
    error,
    fetchData,
    fetchAllData,
  };
}
